export const observeVisibleArchitectures = (
    list: HTMLElement,
    onChange: (ids: readonly string[]) => void,
): (() => void) => {
    const visible = new Set<Element>();
    const observed = new Set<Element>();
    let previousIds = '';

    const publish = (): void => {
        const ids = [...visible]
            .map((element) => element.getAttribute('data-architecture-id'))
            .filter((id): id is string => id !== null)
            .sort();
        const key = ids.join(',');
        if (key !== previousIds) {
            previousIds = key;
            onChange(ids);
        }
    };

    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting && observed.has(entry.target)) visible.add(entry.target);
                else visible.delete(entry.target);
            }
            publish();
        },
        { root: list },
    );

    const update = (): void => {
        const rows = new Set(list.querySelectorAll('[data-architecture-id]'));
        for (const row of observed) {
            if (!rows.has(row)) {
                observer.unobserve(row);
                observed.delete(row);
                visible.delete(row);
            }
        }
        for (const row of rows) {
            if (!observed.has(row)) {
                observed.add(row);
                observer.observe(row);
            }
        }
        publish();
    };

    update();
    const mutations = new MutationObserver(update);
    mutations.observe(list, { childList: true, subtree: true });

    return () => {
        observer.disconnect();
        mutations.disconnect();
        onChange([]);
    };
};
